import { Component, Input, OnInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Deal } from 'app/models/dto/deal.model';
import { UpdateDealDetails } from 'app/store/deal/deal/deal.actions';
import { SalesRepOptions } from 'app/models/dto/sales-rep-options';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserDirectoryState } from 'app/store/user-directory/user-directory.state';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';



@Component({
  selector: 'app-deal-owner-smart',
  templateUrl: './deal-owner-smart.component.html',
  styleUrls: ['./deal-owner-smart.component.scss']
})
export class DealOwnerSmartComponent implements OnInit {

  @Input() deal: Deal;
  @Input() readOnly: boolean = false;
  @Select(UserDirectoryState.users) userDirectory$: Observable<LenderUser[]>;
  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  dealOwnerOptions: SalesRepOptions[];
  canManageDeals: boolean;
  loading = false;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.lenderUser$.pipe(take(1)).subscribe((user) => {
      this.canManageDeals = user.permissions.includes('manageDeals');
    });
  }

  loadOwner() {
    this.loading = true;
    this.userDirectory$.subscribe(users => {
      if (!(users.length > 0)) {
        return;
      }
      const lenderUsers = users.map(user => ({
          label: user.fullName,
          value: user.id
        }));
      lenderUsers.sort((a, b) => {
        const first = a.label.toUpperCase();
        const second = b.label.toUpperCase();
        if (first < second) {
          return -1;
        } else if (first > second) {
          return 1;
        }
        return 0;
      });
      this.dealOwnerOptions = lenderUsers;
      this.loading = false;
    });
  }

  updateOwner(lenderUserId: number) {
    this.loading = true;
    this.store.dispatch(new UpdateDealDetails(this.deal.id, { lenderUserId })).pipe(take(1)).subscribe(() => {
      this.loading = false;
    });
  }
}
